var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-field-layout",
    {
      attrs: {
        validator: _vm.validator,
        "has-focus": _vm.hasFocus,
        "side-grid": _vm.sideGrid,
        "show-required-indicator": _vm.showRequiredIndicator,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "label",
            fn: function () {
              return [
                _vm._t("label", function () {
                  return [
                    _vm.label
                      ? _c("base-label", {
                          attrs: {
                            "input-id": _vm.id,
                            label: _vm.label,
                            "hidden-label": _vm.hiddenLabel,
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "prepend-input",
            fn: function () {
              return [_vm._t("prepend-input")]
            },
            proxy: true,
          },
          {
            key: "append-input",
            fn: function () {
              return [
                _vm._t("append-input", function () {
                  return [
                    _c("icon", {
                      staticClass: "clickable text-primary",
                      attrs: { name: "calendar" },
                      on: {
                        click: function ($event) {
                          return _vm.handleIconClick(_vm.$refs.baseInput)
                        },
                      },
                    }),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "before-input",
            fn: function () {
              return [_vm._t("before-input")]
            },
            proxy: true,
          },
          {
            key: "after-input",
            fn: function () {
              return [_vm._t("after-input")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("v-date-picker", {
        staticClass: "date-picker",
        attrs: {
          masks: _vm.datepickerOptions.masks,
          "model-config": _vm.datepickerOptions.modelConfig,
          attributes: _vm.datepickerOptions.attributes,
          locale: _vm.datepickerOptions.locale,
          popover: {
            visibility: _vm.datepickerOptions.popoverVisibility,
          },
          "min-date": _vm.minDate,
          "max-date": _vm.maxDate,
          color: "primary",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var inputEvents = ref.inputEvents
              return [
                _c(
                  "base-input",
                  _vm._b(
                    {
                      ref: "baseInput",
                      attrs: {
                        value: _vm.valueModel,
                        "input-mask": _vm.inputMask,
                      },
                      on: {
                        focus: function ($event) {
                          inputEvents.focusin($event)
                          _vm.handleBaseFocus($event)
                        },
                        blur: function ($event) {
                          inputEvents.focusout($event)
                          _vm.handleBaseBlur($event)
                          _vm.valueModel = $event.target._value
                        },
                        change: function ($event) {
                          inputEvents.change($event)
                          _vm.handleBaseChange($event, inputEvents)
                        },
                        input: _vm.handleBaseInput,
                      },
                    },
                    "base-input",
                    _vm.$props,
                    false
                  )
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.valueModel,
          callback: function ($$v) {
            _vm.valueModel = $$v
          },
          expression: "valueModel",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }